<template>
  <div class="page public-notice">
    <div class="query-conditions">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-input
            style="min-width: 250px"
            clearable
            v-model="query.form.name"
            placeholder="请输入广告公司名称、产品名称"
            @keyup.enter.native="handleFilter"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select clearable v-model="query.form.release_day" placeholder="请选择释放时间">
            <el-option v-for="item in exportDateOps" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button plain type="primary" @click="handleFilter">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="padding-bottom: 16px;">
      <el-alert
        :closable="false"
        title="提示：仅可查询今天、明天、后天、大后天释放的产品，今天11点后，释放之后的产品无法查询到。"
        type="info"
        show-icon
      >
      </el-alert>
    </div>

    <div class="query-data" v-loading="table.loading">
      <!-- list -->
      <el-table :data="table.list" style="width: 100%">
        <el-table-column prop="product_name" label="产品名称"></el-table-column>
        <el-table-column prop="is_import" label="公示状态" width="180"></el-table-column>
        <el-table-column prop="over_at" label="释放时间" width="240">
          <template slot="header">
            <el-tooltip effect="light" :content="exportTip" placement="bottom">
              <span>释放时间<i class="el-icon-question"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="customer_id" label="客户编号"></el-table-column>
        <el-table-column prop="company" label="广告主公司名称"></el-table-column>
        <el-table-column prop="username" label="归属人" width="160"></el-table-column>
        <el-table-column prop="comment" label="释放理由"></el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';

const req = new Request();

// 释放时间
const ExportDates = [
  { id: 1, name: '今天' },
  { id: 2, name: '明天' },
  { id: 3, name: '后天' },
  { id: 4, name: '大后天' }
];

// 释放提示文案
const ExportTip = '系统将在这个时间点释放此产品，释放后，可立即导入（在公海页面导入）';

export default {
  name: 'AdvertiserManagePublicNotice',
  data() {
    return {
      exportDateOps: ExportDates,
      exportTip: ExportTip,
      table: {
        list: [],
        total: 0,
        loading: false
      },
      query: {
        form: {
          page: 1,
          page_size: 10,
          name: '',
          release_day: ''
        }
      }
    };
  },
  methods: {
    // 获取列表数据
    async _getList() {
      try {
        this.table.loading = true;
        const res = await req.send(req.Apis.sales.product.publicNotice, this.query.form).fin(() => {
          this.table.loading = false;
        });
        const dv = res.data || {};
        this.table.list = [...(dv.data || [])];
        this.table.total = (dv.total || 0) * 1;
      } catch (err) {
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    // 筛选
    handleFilter() {
      this.query.form.page = 1;
      this._getList();
    },

    // 页量改变
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = pageSize * 1;
      this._getList();
    },

    // 页码改变
    handleQueryPage(page) {
      this.query.form.page = page * 1;
      this._getList();
    }
  },
  created() {
    this._getList();
  }
};
</script>
